import { isCurrentYear } from '~/utils/schoolYearState';

/**
 * The year Tuition & fees opens on, and the one the settings overview
 * summarizes: the current year, else the first listed.
 */
export function openingPricesYear<T extends { state: string }>(years: readonly T[]): T | undefined {
  return years.find(isCurrentYear) ?? years[0];
}
